import { ParameterData } from '@/features/ocr/types/ParameterData';
import { BASE_URL } from '@/utils/Constants';
import { useAuth } from '@/utils/stores/useAuthStore';
import { useQuery } from '@tanstack/react-query';

const getDocumentDetail = async (
  docId: string,
  token: string,
  user_id: string,
) => {
  const response = await fetch(
    `${BASE_URL}/api/anamnestic-data/data-points/user/${user_id}/document/${docId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const data = await response.json();

  if (!response.ok) {
    throw new Error('Failed to fetch document detail');
  }

  return data as ParameterData[];
};

export const useGetDocumentDetail = (docId: string) => {
  const { idToken, userId } = useAuth();
  const { data, isLoading, error } = useQuery({
    queryKey: ['documentDetail', docId, idToken, userId],
    queryFn: () => getDocumentDetail(docId, idToken!, userId!),
    enabled: !!docId && !!idToken && !!userId,
  });
  return { data, isLoading, error };
};
